import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl _mb-6 _pt-6"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_comments_section = _resolveComponent("comments-section")
  const _component_project_description = _resolveComponent("project-description")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    ($options.isCommentSectionVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_comments_section, _normalizeProps(_guardReactiveProps($props.comments)), null, 16 /* FULL_PROPS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_project_description, _normalizeProps(_guardReactiveProps($props.descriptionModel)), null, 16 /* FULL_PROPS */)
  ]))
}